import RoleHome from '../RoleHome';

export default function WardSupervisorPage() {
  return (
    <RoleHome
      title="Ward supervisor"
      description="Wards, beds, admissions, transport, and diet oversight."
    />
  );
}
